import {Component, OnInit, input} from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import {ToastrService} from 'ngx-toastr';


@Component({
    selector: 'app-copy-href',
    templateUrl: './copy-href.component.html',
    styleUrls: ['./copy-href.component.scss'],
    standalone: false
})
export class CopyHrefComponent implements OnInit {

  link: string;
  readonly copyText = input<string>(undefined);

  constructor(
    private _clipboardService: ClipboardService,
    private notifierService: ToastrService
  ) { }

  ngOnInit() {
    this.link = location.href;
  }

  copy() {
    this._clipboardService.copyFromContent(this.link);
    this.notifierService.success('Link copied! Feel free to share it with people');
  }

}
